import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Menu, MenuProps, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { mergeSlotProps } from '@mui/material/utils';
import { useCallback, useState } from 'react';

interface SplitToggleButtonWithPopperProps {
  buttonLabel: string;
  buttonValue: string;
  className?: string;
  selectedValue?: string;
  menuContent: React.ReactElement;
  iconButtonClassName?: string;
  iconSize?: {
    width: number;
    height: number;
  };
  menuProps?: Omit<MenuProps, 'open' | 'onClose' | 'anchorEl'>;
  onClickMainButton: () => void;
  onCloseDropdown?: () => void;
  disabled?: boolean;
}

const SplitToggleButtonWithPopper = ({
  iconSize,
  menuProps,
  className,
  buttonValue,
  menuContent,
  buttonLabel,
  selectedValue,
  iconButtonClassName,
  onClickMainButton,
  onCloseDropdown,
  disabled,
}: SplitToggleButtonWithPopperProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggle = useCallback(() => {
    setIsMenuOpen((prevOpen) => !prevOpen);
  }, []);

  const handleClose = useCallback(() => {
    setIsMenuOpen(false);
    onCloseDropdown?.();
  }, [onCloseDropdown]);

  return (
    <div ref={setAnchorEl}>
      <ToggleButtonGroup value={selectedValue}>
        <ToggleButton
          tabIndex={-1}
          size="small"
          value={buttonValue}
          className={className}
          onClick={onClickMainButton}
          disabled={disabled}
        >
          {buttonLabel}
        </ToggleButton>
        <ToggleButton
          size="small"
          tabIndex={-1}
          value={buttonValue}
          className={iconButtonClassName}
          onClick={handleToggle}
          disabled={disabled}
        >
          {isMenuOpen ? (
            <KeyboardArrowUpIcon fontSize="small" style={iconSize} />
          ) : (
            <KeyboardArrowDownIcon fontSize="small" style={iconSize} />
          )}
        </ToggleButton>
      </ToggleButtonGroup>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        {...menuProps}
        slotProps={mergeSlotProps(menuProps?.slotProps, { list: { disablePadding: true } })}
      >
        {menuContent}
      </Menu>
    </div>
  );
};

export default SplitToggleButtonWithPopper;
